var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAreaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_768_2047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 4.16667C2.5 4.60869 2.67559 5.03262 2.98816 5.34518C3.30072 5.65774 3.72464 5.83333 4.16667 5.83333C4.60869 5.83333 5.03262 5.65774 5.34518 5.34518C5.65774 5.03262 5.83333 4.60869 5.83333 4.16667C5.83333 3.72464 5.65774 3.30072 5.34518 2.98816C5.03262 2.67559 4.60869 2.5 4.16667 2.5C3.72464 2.5 3.30072 2.67559 2.98816 2.98816C2.67559 3.30072 2.5 3.72464 2.5 4.16667Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.168 4.16667C14.168 4.60869 14.3436 5.03262 14.6561 5.34518C14.9687 5.65774 15.3926 5.83333 15.8346 5.83333C16.2767 5.83333 16.7006 5.65774 17.0131 5.34518C17.3257 5.03262 17.5013 4.60869 17.5013 4.16667C17.5013 3.72464 17.3257 3.30072 17.0131 2.98816C16.7006 2.67559 16.2767 2.5 15.8346 2.5C15.3926 2.5 14.9687 2.67559 14.6561 2.98816C14.3436 3.30072 14.168 3.72464 14.168 4.16667Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 15.8307C2.5 16.2728 2.67559 16.6967 2.98816 17.0092C3.30072 17.3218 3.72464 17.4974 4.16667 17.4974C4.60869 17.4974 5.03262 17.3218 5.34518 17.0092C5.65774 16.6967 5.83333 16.2728 5.83333 15.8307C5.83333 15.3887 5.65774 14.9648 5.34518 14.6522C5.03262 14.3397 4.60869 14.1641 4.16667 14.1641C3.72464 14.1641 3.30072 14.3397 2.98816 14.6522C2.67559 14.9648 2.5 15.3887 2.5 15.8307Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.168 15.8307C14.168 16.2728 14.3436 16.6967 14.6561 17.0092C14.9687 17.3218 15.3926 17.4974 15.8346 17.4974C16.2767 17.4974 16.7006 17.3218 17.0131 17.0092C17.3257 16.6967 17.5013 16.2728 17.5013 15.8307C17.5013 15.3887 17.3257 14.9648 17.0131 14.6522C16.7006 14.3397 16.2767 14.1641 15.8346 14.1641C15.3926 14.1641 14.9687 14.3397 14.6561 14.6522C14.3436 14.9648 14.168 15.3887 14.168 15.8307Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.16797 5.83594V14.1693",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83203 4.16406H14.1654",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83203 15.8359H14.1654",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.832 5.83594V14.1693",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_768_2047"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreaIcon);
export default __webpack_public_path__ + "static/media/area-icon.e5c8cd975d1dcd7b2c8ae8cb6fdaa2b6.svg";
export { ForwardRef as ReactComponent };